import React from 'react';
import { getListingAvailability } from '../../util/listingAvailability.shared';
import css from './ListingPageMarketplace.module.css';

// Early Work & Share imports used these source columns directly. Only use them
// when the source office key confirms the site; unrelated advertisers may use
// similarly named custom fields with a different meaning.
export const officePublicData = listing => {
  const publicData = listing?.attributes?.publicData || {};
  const site = String(publicData.wsEspace || publicData.espace || '').trim();
  const keyParts = String(publicData.wsBureauId || '').split('::');
  const confirmedWorkAndShare =
    site &&
    keyParts.length === 3 &&
    keyParts[0] === site &&
    keyParts[1].trim() &&
    keyParts[2].trim();
  if (!confirmedWorkAndShare) return publicData;
  const present = value => value != null && String(value).trim() !== '';
  return {
    ...publicData,
    wsNumBureau: present(publicData.wsNumBureau) ? publicData.wsNumBureau : publicData.numBureau,
    seatedStations: present(publicData.seatedStations)
      ? publicData.seatedStations
      : publicData.nbPostes,
    areaSize: present(publicData.areaSize) ? publicData.areaSize : publicData.surfaceM2,
  };
};

export const officeTitle = listing => {
  const { title = '' } = listing?.attributes || {};
  const publicData = officePublicData(listing);
  const ref = publicData.wsNumBureau;
  if (ref == null || String(ref).trim() === '') return title;
  const seats = Number(publicData.seatedStations);
  const capacity =
    Number.isFinite(seats) && seats > 0 ? ` · ${seats} poste${seats > 1 ? 's' : ''}` : '';
  return `Bureau ${ref}${capacity}`;
};

// Only retain the current listings route and its filters. Router state must not
// turn the return link into an arbitrary destination.
export const locationListingsReturn = (state, listingPath, groupId, locationKey) => {
  const from = state?.fromListings;
  const search =
    typeof from === 'string' && from.startsWith(`${listingPath}?`)
      ? from.slice(listingPath.length).split('#')[0]
      : '';
  const page = Number(state?.fromListingsPage);
  return {
    search,
    state: {
      expandedGroupId: state?.fromGroupId || groupId,
      expandedLocationKey: locationKey,
      selectedListingId: groupId,
      listingsPage: Number.isInteger(page) && page > 0 ? page : 1,
    },
  };
};

const LocationOfficeSelector = ({
  currentListing,
  listings,
  onSelect,
  id = 'location-office-selector',
}) => {
  if (!Array.isArray(listings) || listings.length < 2) return null;
  const sorted = listings.slice().sort((a, b) => {
    const availableFirst =
      Number(getListingAvailability(b).available) - Number(getListingAvailability(a).available);
    return availableFirst || officeTitle(a).localeCompare(officeTitle(b), 'fr', { numeric: true });
  });
  return (
    <div className={css.officeSelector}>
      <label htmlFor={id}>Un autre bureau à cette adresse ?</label>
      <select
        id={id}
        value={currentListing.id.uuid}
        onChange={event => {
          const office = sorted.find(item => item.id.uuid === event.target.value);
          if (office && office.id.uuid !== currentListing.id.uuid) onSelect(office);
        }}
      >
        {sorted.map(office => {
          const availability = getListingAvailability(office);
          return (
            <option key={office.id.uuid} value={office.id.uuid}>
              {officeTitle(office)} · {availability.available ? 'Disponible' : availability.label}
            </option>
          );
        })}
      </select>
      <p>Chaque bureau possède son tarif et sa disponibilité.</p>
    </div>
  );
};

export default LocationOfficeSelector;
